const items = [
  "Federal Procurement",
  "OSHA 510 Certified",
  "ServSafe Instruction",
  "EMBA · Georgetown McDonough",
  "Certified Scrum Master",
  "Toyota Lexus Minority Dealers Assoc.",
  "Forbes · Avenue Magazine '18",
];

export const BrandStrip = () => {
  return (
    <section
      data-testid="brand-strip"
      className="relative border-y border-white/10 bg-[#070d1a] overflow-hidden"
    >
      <div className="py-6 overflow-hidden">
        <div className="marquee-track whitespace-nowrap">
          {[...items, ...items].map((t, i) => (
            <div
              key={i}
              className="flex items-center gap-10 px-8 text-[11px] uppercase tracking-[0.32em] text-slate-500"
            >
              <span className="text-slate-400">{t}</span>
              <span className="w-1 h-1 rounded-full bg-[#d4af37]/60" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BrandStrip;
